<template>
  <div class="wizard">
    <div class="main">
      <div class="taxgift-intro">
        <p>
          <b>{{ $t("integration.ambassadorapp_title", "Ambassador App") }}</b>
        </p>
      </div>

      <p>
        {{ $t("integration.ambassadorapp_description", "Ambassador App description") }}
      </p>

      <b-form-group
        id="ambassadorapp-fieldset-select-campaign"
        :label="$t('integration.filters_campaign_title', 'Pick campaign to generate API key for')"
        label-for="ambassadorapp-input-select-campaign"
      >
        <multiselect
          id="ambassadorapp-input-select-campaign"
          v-model="campaign"
          :options="campaigns"
          :custom-label="customLabel"
          :loading="loadingCampaigns"
          :allow-empty="false"
          track-by="id"
          :placeholder="$t('reports.filters_select_campaign', 'Select campaign')"
          :select-label="$t('reports.select_campaign_select_label', 'Press enter to select')"
          :deselect-label="$t('reports.select_campaign_deselect_label', 'Press enter to remove')"
          :selected-label="$t('reports.select_campaign_selected_label', 'Selected')"
        />
      </b-form-group>

      <b-form-group class="terms-group">
        <b-form-checkbox v-model="termsAccepted" id="ambassadorapp-terms-checkbox">
          {{ $t("integration.ambassadorapp_terms_prefix", "I agree to the") }}
          <a
            :href="$t('integration.ambassadorapp_terms_url', 'https://www.charidy.com/terms')"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ $t("integration.ambassadorapp_terms_link", "Terms and Conditions") }}
          </a>
        </b-form-checkbox>
      </b-form-group>
    </div>
    <div class="footer">
      <button class="bttn bttn--lg bttn--blue" @click.prevent="closeModal">
        {{ $t("integration.close") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        :disabled="!campaign || !termsAccepted"
        @click.prevent="addIntegration"
      >
        {{ $t("integration.add_taxgift", "Add Integration") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  data() {
    return {
      sandbox: false,
      campaign: null,
      termsAccepted: false,
    };
  },

  created() {
    this.$store.dispatch("getCampaigns");
  },

  computed: {
    ...mapState({
      orgId: () => {
        return localStorage.getItem("orgId");
      },
      campaigns: (state) => state.campaigns.campaigns,
      loadingCampaigns: (state) => state.campaigns.loadingCampaigns,
    }),
  },

  watch: {
    loadingCampaigns() {
      this.setCampaign();
    },
  },

  methods: {
    customLabel(cmp) {
      return cmp.id && `[${cmp.id}] ${cmp.attributes.title}`;
    },
    setCampaign() {
      if (this.campaigns.length === 1) {
        this.campaign = this.campaigns[0];
      } else if (this.campaigns.length > 1) {
        this.campaign = this.campaigns.filter((el) => el.attributes.category === "regular")[0];
      }
    },
    closeModal() {
      this.$store.dispatch("getIntegrationsList");
      this.$emit("close-modal");
    },
    addIntegration() {
      if (!this.campaign || !this.termsAccepted) return;
      const payload = {
        status: true,
        sandbox: this.sandbox,
      };
      axios
        .post(urls.addAmbassadorAppIntegration(this.orgId, this.campaign.id), payload)
        .then(() => {
          this.$_notificationsMixin_makeToast("Success", this.$t("account.success_edit"));
          this.$emit("close-modal");
          this.$store.dispatch("getIntegrationsList");
        })
        .catch(this.$_notificationsMixin_handleCatch);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
}
.el-right {
  margin-left: auto;
}
.terms-group {
  margin-top: 20px;
}
</style>
